import KingsmanShop from "../assets/images/portfolio/KingsmanShop.png";
import MonsterRolodex from "../assets/images/portfolio/MonsterRolodex.png"

const projectsData = [
  {
    id: "rest-countries",
    img: KingsmanShop,
    name: "Rest Countires",
    stack: ["< React Router />", "< Firebase />", "< SCSS />", "< React.js />"],
    src: "https://kingsmanshop.netlify.app/",
    source: "https://github.com/imshubhamchavan/KingsmanShop",
    description:
      "KingsmanShop is an e-commerce website that has clothing products. There is a cart where you can see added items and edit, add, or remove them.",
  },
  //  {
  //    id: "MonsterRolodex",
  //     img: MonsterRolodex,
  //    name: "URL Shortener",
  //    stack: ["< HTML5 />", "< CSS />", "< JSX />", "< RESTful API />"],
  //    src: "https://imshubhamchavan.github.io/Monster-Rolodex/",
  //    source: "https://github.com/imshubhamchavan/Monster-Rolodex",
  //    description:
  //      "Monster Rolodex: A project that interacts with API with the ability to filter and search, you can easily navigate",
  //  },
];

export { projectsData };
